
import { Component, Prop, Vue } from "vue-property-decorator";
import { MahnungDto } from "@/dtos/mahnungDto";
import { AddressDto } from "@/dtos/addressDto";
import { ErpAddressType } from "@/dtos/erpAddressType";

interface AddressEntry {
	label: string;
	address: AddressDto;
}

@Component
export default class MahnungAddressOverview extends Vue {
	@Prop()
	private mahnung!: MahnungDto;

	private get addressEntries(): AddressEntry[] {
		const entries: AddressEntry[] = [];

		if (this.mahnung.customerAddress) {
			entries.push({
				label: "Kunden-Stammadresse",
				address: this.mahnung.customerAddress,
			});
		}

		const invoiceAddresses = this.mahnung.customerAddresses.filter(
			(a) => a.type === ErpAddressType.Invoice
		);
		invoiceAddresses.forEach((address, index) => {
			const suffix = invoiceAddresses.length > 1 ? ` ${index + 1}` : "";
			entries.push({
				label: `Kunden-Rechnungsadresse${suffix}${address.isDefault ? " (Standard)" : ""}`,
				address,
			});
		});

		const deliveryAddresses = this.mahnung.customerAddresses.filter(
			(a) => a.type === ErpAddressType.Delivery
		);
		deliveryAddresses.forEach((address, index) => {
			const suffix = deliveryAddresses.length > 1 ? ` ${index + 1}` : "";
			entries.push({
				label: `Kunden-Lieferadresse${suffix}${address.isDefault ? " (Standard)" : ""}`,
				address,
			});
		});

		this.mahnung.mahnungsPositions.forEach((position) => {
			if (position.invoiceAddress) {
				entries.push({
					label: `Rechnungsadresse Rechnung ${position.invoiceId}`,
					address: position.invoiceAddress,
				});
			}
		});

		return entries;
	}

	private select(address: AddressDto) {
		this.$emit("select", JSON.parse(JSON.stringify(address)));
	}
}
